import { render } from "./dialogCambiarAlias.vue?vue&type=template&id=a377a4a2&scoped=true"
import script from "./dialogCambiarAlias.vue?vue&type=script&lang=js"
export * from "./dialogCambiarAlias.vue?vue&type=script&lang=js"

import "./dialogCambiarAlias.vue?vue&type=style&index=0&id=a377a4a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a377a4a2"]])

export default __exports__